import { RuntimePracticeCenterScreen } from '@/features/unified-learning/runtime/screens/RuntimePracticeCenterScreen';

export default function LearnPracticeCenterRoute() {
  return <RuntimePracticeCenterScreen runtimeBase="/learn/path" />;
}
